import { Box, Link, Modal, Typography } from '@mui/material'
import { useRouter } from 'next/router'
import React from 'react'
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

export default function School_begins_enrollment() {

  const [newOpen, setNewOpen] = useState(false);

  const router = useRouter()
  const handleNewOpen = () => setNewOpen(true);
  const handleNewClose = () => setNewOpen(false);

  const gotoInnerMysteries =() => router.push("/inner-mysteries");

  return (
    <>
      <div className='SBE_main_block'>

        {/* <div className="text_yellow_wrpr">
          <Link href="/tarot-astrology-certification" onClick={(e) => {
            e.preventDefault(); 
            router.push('/tarot-astrology-certification'); 
          }}>
            Enrollment is now open for our Winter session 2026 Astrology/Tarot Certification
          </Link>
          
        </div> */}

         <div className="text_yellow_wrpr">
          <div className="text_yellow_sub_sec_souwrpr">
          
            <span>Apply and Join:</span>
            <Link href="/astrology-community"><button>Astrology Community</button></Link>
            <Link href="/diviner-academy"><button>Divination Academy</button></Link>
            {/* <button onClick={handleNewOpen}>Inner Mysteries</button> */}
            <button onClick={gotoInnerMysteries}>Inner Mysteries</button>
         </div>
          
        </div>
        <Link href="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/Mystery_School_PDF.pdf" target="_blank"><div className="text_yellow_wrpr_cmn_pdf_sec">
           Inner Mystery Pdf
            <img src="/image/ritualpraxis_blockone_btn_banner_icon.png"/>
        </div></Link>
      </div>


      <Modal
        open={newOpen}
        onClose={handleNewClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box_new">
          <Typography
            id="modal-modal-description" component="div"
            sx={{ mt: 2 }}
            className="modal_banner_new"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleNewClose}>
                <CloseIcon />
              </span>
              <img
                src="/image/logobanner.webp"
                alt="bannerLogo"
              />
              <p className="modal_commingsoon">Coming soon</p>
            </div>
          </Typography>
        </Box>
      </Modal>

    </>
  )
}
